<template>
  <div class="news_details_wrap news-detail-page">
    <PCNavbar selectIndex="4-2"/>
    <MobileNavBar :currentActive="3"/>
    <div class="news_content">
      <el-breadcrumb class="news_bread" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>

      <article class="news_article">
        <header class="news_article_header">
          <h1 class="news_title">
            中亚市场合作伙伴莅临我司交流 共商哈萨克斯坦充电桩合作
          </h1>
          <div class="news_meta">
            <span class="news_meta_item">来源：山东智能工业装备公司</span>
            <span class="news_meta_sep">·</span>
            <span class="news_meta_item">投稿时间：2026-10-27</span>
          </div>
        </header>

        <div class="article_body">
          <p class="lead">
            近日，中亚市场合作伙伴一行莅临山东智能工业装备有限公司参观交流。双方围绕哈萨克斯坦等中亚地区新能源重卡充电基础设施建设、充电设备出口配套及运营平台合作等事宜进行深入沟通，并就合作方向达成初步共识。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img1"
              alt="双方座谈交流"
            >
            <figcaption class="figure_caption">双方座谈交流，共商中亚充电业务合作</figcaption>
          </figure>

          <h2 class="section_title">一、现场参观，了解产品与技术能力</h2>

          <p class="body_paragraph">
            来访嘉宾参观了我司充电设备调试区与产品展示区，重点了解「鲸王」智能快充终端、大功率充电堆等核心产品。我司技术人员现场拆解介绍了充电柜内部模块架构、散热与电气安全设计，并围绕设备性能、场景适配及海外项目交付能力进行了详细讲解。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img2"
              alt="鲸王智能快充终端现场介绍"
            >
            <figcaption class="figure_caption">我司技术人员现场介绍「鲸王」智能快充终端及充电柜结构</figcaption>
          </figure>

          <h2 class="section_title">二、座谈交流，明确合作方向</h2>

          <p class="body_paragraph">
            座谈中，合作方介绍了其在中亚地区依托中国重汽电动重卡销售网络推进配套充电桩建设与运营的业务规划，希望引入我司充电设备，并由我司协助开发充电运营平台，形成“整车销售 + 充电补能 + 平台运营”的一体化服务能力，服务哈萨克斯坦等中亚市场客户。
          </p>

          <p class="body_paragraph">
            我司就充电桩产品选型、场站建设方案、平台功能规划及后续运维支持等事项作了专题交流。双方一致认为，中亚新能源重卡市场增长潜力明显，充电基础设施配套需求旺盛，具备良好合作基础。经充分沟通，双方已就设备供应、平台合作及市场推进节奏等关键事项达成初步共识。
          </p>

          <h2 class="section_title">三、下一步工作</h2>

          <p class="body_paragraph">
            此次交流进一步增进了双方互信，也为我司充电产品与平台能力拓展海外市场积累了重要合作契机。下一步，双方将加快推进方案细化与项目落地，推动「鲸王」充电设备及运营平台服务中亚新能源重卡补能需求，助力区域绿色交通发展。
          </p>
        </div>
      </article>
    </div>

    <div class="news_detail_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      images: {
        img1: require('@/assets/images/news-list/news13/image1.jpg'),
        img2: require('@/assets/images/news-list/news13/image2.jpg'),
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/news-detail-responsive.scss';
</style>
